module.exports = __webpack_public_path__ + "static/media/82.4725e618.wav";